
const projects = [
    {
        title: "Embedded & Real-Time Systems",
        summary: "Current professional work on timing-critical radio systems, including low-latency control software, hardware/software interfaces, and automated test infrastructure.",
        technologies: ["C++", "Embedded Systems", "Real-Time Software", "Test Automation"]
    },
    {
        title: "Paper-Trade",
        summary: "An open-source trading platform that uses Python and AWS, with ongoing work toward a React frontend and database-backed aggregations.",
        technologies: ["Python", "AWS", "React", "Databases"],
        links: [
            { label: "View on GitHub", href: "https://github.com/bri-davis/paper-trade" }
        ]
    },
    {
        title: "3D Human Pose Estimation",
        summary: "A computer-vision project exploring deep-learning architectures for estimating 3D human pose from a single image.",
        technologies: ["Python", "PyTorch", "Computer Vision", "Machine Learning"]
    },
    {
        title: "Robotic Traffic Flow",
        summary: "A robotic emulation of vehicular traffic flow, combining motion control software with real-world traffic-model evaluation.",
        technologies: ["Python", "Robotics", "Motion Control", "Modeling"],
        links: [
            { label: "View on GitHub", href: "https://github.com/bri-davis/C2M2" }
        ]
    }
];

export default function Projects() {
    return (
        <main className="projects-page">
            <header className="projects-intro">
                <h1>Projects</h1>
                <p>A selection of technical projects and experiments.</p>
            </header>

            <section className="project-grid" aria-label="Projects">
                {projects.map((project) => (
                    <article className="project-card" key={project.title}>
                        <h2>{project.title}</h2>
                        <p>{project.summary}</p>
                        <ul className="technology-list" aria-label={`${project.title} technologies`}>
                            {project.technologies.map((technology) => (
                                <li key={technology}>{technology}</li>
                            ))}
                        </ul>
                        {project.links && (
                            <div className="project-links">
                                {project.links.map((link) => (
                                    <a href={link.href} key={link.href} target="_blank" rel="noreferrer">
                                        {link.label}
                                    </a>
                                ))}
                            </div>
                        )}
                    </article>
                ))}
            </section>
        </main>
    );
}
